import React, {useEffect, useState} from "react";
import {Modal} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import alertService from "../../../_services/cart/alert.service";
import impersonacionService from "../../../_services/cart/impersonacion.service";

const nombreDe = (m) => (m.fullName || `${m.firstName || ""} ${m.lastName || ""}`).trim() || m.email;

/**
 * Elegir a quien de una cuenta impersonar: el dueño o uno de sus empleados. Entrar como un empleado sirve
 * para ver lo que ve con su rol (los permisos son los suyos); para configurar la cuenta, el dueño.
 */
export const ImpersonarCuentaModal = ({cuenta, onClose}) => {
    const [miembros, setMiembros] = useState(null);
    const [entrando, setEntrando] = useState(null);

    useEffect(() => {
        if (!cuenta) return;
        setMiembros(null);
        impersonacionService.miembros(cuenta.cuentaId)
            .then(setMiembros)
            .catch((err) => {
                alertService.error(err?.message || "No se pudieron traer los usuarios de la cuenta");
                onClose();
            });
    }, [cuenta, onClose]);

    const entrar = (m) => {
        setEntrando(m.userId);
        impersonacionService.entrar(m.userId, {nombre: nombreDe(m), email: m.email, cuentaNombre: cuenta.cuentaNombre})
            .catch((err) => {
                setEntrando(null);
                alertService.error(err?.message || "No se pudo entrar como este usuario");
            });
    };

    return (
        <Modal show={!!cuenta} onHide={onClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Entrar a {cuenta?.cuentaNombre}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p className="panel__bajada">
                    Vas a ver y hacer todo como esa persona, con sus permisos. Lo que cargues queda a su nombre.
                    Para volver a tu usuario, usá el cartel de arriba.
                </p>
                {miembros === null && <p className="cuenta-usuarios__vacio">Cargando…</p>}
                {miembros !== null && miembros.length === 0 && (
                    <p className="cuenta-usuarios__vacio">La cuenta no tiene usuarios.</p>
                )}
                {miembros !== null && miembros.length > 0 && (
                    <ul className="impersonar__lista">
                        {miembros.map((m) => (
                            <li key={m.userId} className="impersonar__item">
                                <div>
                                    <p className="cuenta-usuarios__nombre">
                                        {nombreDe(m)}{m.esDuenio && <span className="impersonar__dueno">Dueño</span>}
                                    </p>
                                    <p className="cuenta-usuarios__username">
                                        {m.email}{m.rolCuentaNombre ? ` · ${m.rolCuentaNombre}` : ""}
                                    </p>
                                </div>
                                <button type="button" className="button" data-type="primary"
                                        disabled={entrando !== null} onClick={() => entrar(m)}>
                                    <FontAwesomeIcon icon="fa-solid fa-user-secret"/>{" "}
                                    {entrando === m.userId ? "Entrando…" : "Entrar"}
                                </button>
                            </li>
                        ))}
                    </ul>
                )}
            </Modal.Body>
        </Modal>
    );
};
